<p class="otp-p otp-p__body--highlight" i18n>Полезни връзки</p>
<section>
  <a routerLink="/site-rules" class="dsk-link" [replaceUrl]="isMortgageApplicationPath()" i18n>Правила и условия за ползване</a>
  <a routerLink="/terms-and-conditions" class="dsk-link" [replaceUrl]="isMortgageApplicationPath()" i18n>Политика за поверителност</a>
  <a
    class="dsk-link"
    target="_blank"
    href="https://dskbank.bg/docs/default-source/gdpr/информация-относно-обработването-на-лични-данни-на-физически-лица-от-банка-дск-ад-и-съгласия-за-обработване-на-лични-данни.pdf"
    i18n>
    Обработване на лични данни
  </a>
  <a
    class="dsk-link"
    target="_blank"
    href="https://dskbank.bg/docs/default-source/финансови-услуги-от-разстояние/условия-за-предоставяне-на-финансови-услуги-от-разстояние.pdf"
    i18n>
    Финансови услуги от разстояние
  </a>
</section>
<section>
  <a class="dsk-link" target="_blank" href="https://dskdom.bg" i18n>ДСК Дом</a>
  <a class="dsk-link" target="_blank" href="https://dskbank.bg/бизнес-клиенти/дск-агро" i18n>ДСК Агро</a>
  <a class="dsk-link" target="_blank" href="http://www.dskam.bg/page/default.aspx?xml_id=/bg-BG/" i18n>ДСК Управление на активи АД</a>
  <a class="dsk-link" target="_blank" href="https://dskrodina.bg/" i18n>ПОК ДСК РОДИНА</a>
  <a class="dsk-link" target="_blank" href="https://www.otpleasing.bg/" i18n>ОТП Лизинг</a>
  <a class="dsk-link" target="_blank" href="https://otpbroker.bg/" i18n>ОТП Застрахователен Брокер</a>
  <a class="dsk-link" target="_blank" href="https://www.novakola.bg/" i18n>Нова Кола</a>
</section>
<section>
  <a class="dsk-link" target="_blank" href="https://dskbank.bg" i18n>Банка ДСК</a>
  <a
    class="dsk-link"
    target="_blank"
    href="https://dskbank.bg/индивидуални-клиенти/електронно-банкиране/dsk-mobile?ConsultantReference=DSK-Mobile_Nav&utm_source=Nav_DSK-Mobile&utm_medium=Nav_HomePage&utm_campaign=HP_navigation"
    i18n>
    DSK Mobile
  </a>
  <a
    class="dsk-link"
    target="_blank"
    href="https://dskbank.bg/индивидуални-клиенти/за-банка-дск/оферти-за-продажби?offercategory=1&type=1&price=1000000"
    i18n>
    Оферти за продажба от Банка ДСК
  </a>
  <a class="dsk-link" target="_blank" href="https://dskbank.bg/контакти/клонова-мрежа" i18n>Клонова мрежа и банкомати</a>
</section>
